import { useContext } from 'react';
import { axiosClient } from '../../../../../../library/Service/axiosClient';
import { SmartContext } from '../../../../../../library/Core/SmartContext';
import axios from 'axios';

const ProfileMarkerService = () => {
    const { state, dispatch } = useContext(SmartContext);
    async function fetchUserProfileMarkers(userId) {
        const markersData = (await axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/get-markers`,
                {userId : userId, instituteId : state.data.selectedInstitute?.instituteId}) ) ?? [];
        
        dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: { dataKey: 'marker', value: markersData?.data },
        });
        
        return markersData?.data || [];
    }

    // Function to update marker data
    async function saveWorkRelatedMarker(updatedMarker, userId) {
        const markersData =
            (await axiosClient().post(
                `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/save-work-profile-marker`,
                 {userId: userId, instituteId: state.data.selectedInstitute?.instituteId, updatedMarker})) ?? [];
    }

    // Function to update marker data
    async function saveMarker(updatedMarker, userId) {
        const markersData =
            await (axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/save-marker`,
                {userId: userId, instituteId: state.data.selectedInstitute?.instituteId,...updatedMarker}) ) ?? []
    }

    async function fetchUserFromSameInstitute(userId,type) {
        console.log("state.data.selectedInstitute?.instituteId",state.data.selectedInstitute?.instituteId)
        const markersData =
            (await axiosClient().post(
                `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/get-student-from-same-institute-by-userid`,
                {userId: userId, type : type, instituteId : state.data.selectedInstitute?.instituteId }
            )) ?? [];

        return markersData?.data || [];
    }

    async function fetchAffinityRelatedCountsByUserId(userId, userEmail, instituteId) {
        try {
            const response = await axiosClient().post(
                `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/get-affinity-relatedcount-by-userid`,
                { userId, userEmail, instituteId : state.data.selectedInstitute?.instituteId ?? instituteId }  
            );
                return response?.data || [];
        } catch (error) {
            console.error("Error fetching affinity-related counts:", error);
            return []; 
        }
    }
    
    async function fetchUserProfileMarkersLogs(userId, instituteId) {
        const markersLogData =
            (await axiosClient().post(
                `${process.env.REACT_APP_ADMIN_API_SERVER}/markers/get-marker_logs-by-userid`,
                {userId : userId, instituteId : state.data.selectedInstitute?.instituteId ?? instituteId}
            )) ?? [];

        return markersLogData?.data || [];
    }

    async function handleOpenLogsModal(uuid='', instituteId= '') {
        const LogsData = await fetchUserProfileMarkersLogs(state?.data?.id  ?? uuid, instituteId);
        dispatch({
            type: 'SET_MODAL_DATA',
            payload: { data: [LogsData] },
        });
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showprofileMarkerLogs' } });
    };

    async function fetchUserSyncDetails(userId) {
        const markersData =
            (await axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/get-user-marker-syncdata`,
                {userId : userId}
            )) ?? [];  
        return markersData?.data || [];
    }

     async function fetchPlatformUsageRelatedCountsByUserId(userId) {
        try {
            const response = await axiosClient().post(
                `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/get-platformusgae-relatedcount-by-userid`,
                { userId,instituteId : state.data.selectedInstitute?.instituteId  }  
            );
                return response?.data || [];
        } catch (error) {
            console.error("Error fetching affinity-related counts:", error);
            return []; 
        }
    }

    
    // async function getResponsdedFeedbackSurvey(userId, instituteId) {
    //     try {
    //         const response = await axiosClient().post(
    //             `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/get-responsed-feedbacksurvey-by-userid`,
    //             { userId, instituteId : state.data.selectedInstitute?.instituteId ?? instituteId }  
    //         );

    //         return response?.data || [];
    //     } catch (error) {
    //         console.error("Error fetching affinity-related counts:", error.response?.data || error.message);
    //         return [];
    //     }
    // }

    async function saveSuggestionResponse(markerField, userId, status) {
        try {
            const response = await axiosClient().post(
                `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/markers/save-suggestion-response`,
                { markerField, userId, status }  
            );

            return response?.data || [];
        } catch (error) {
            console.error("Error saving suggestion response:", error.response?.data || error.message);
            return [];
        }
    }

    return {
        fetchUserFromSameInstitute,
        saveMarker,
        saveWorkRelatedMarker,
        fetchUserProfileMarkers,
        fetchAffinityRelatedCountsByUserId,
        fetchUserProfileMarkersLogs,
        handleOpenLogsModal,
        fetchUserSyncDetails,
        fetchPlatformUsageRelatedCountsByUserId,
        saveSuggestionResponse
    };
};

export default ProfileMarkerService;
